export default {
  meta: {
    title: '集客点报表',
    url: '/report/planspot' // 埋点用，记录所属模块
  }
};
